module.exports = __webpack_public_path__ + "img/MEDIA007.bcc75fb3.jpg";